import { useState } from 'react';
import { toast } from 'sonner';
import { UserPlus, Loader2 } from 'lucide-react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

// İşten ayrılmış çalışanı yeni başlangıç tarihi + firma ile yeniden işe alır.
export function RehireDialog({ user, firms, onDone }) {
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [firmId, setFirmId] = useState(user.firm_id || '');
  const [saving, setSaving] = useState(false);
  const endDate = (user.employment_end_date || '').slice(0, 10);

  const submit = async () => {
    if (!startDate || !firmId) { toast.error('Başlangıç tarihi ve firma seçin'); return; }
    setSaving(true);
    try {
      const res = await api.post(`/admin/users/${user.id}/rehire`, { employment_start_date: startDate, firm_id: firmId });
      toast.success(res.data?.message || 'Yeniden işe alındı');
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'İşlem başarısız');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button size="sm" className="ml-auto bg-emerald-600 hover:bg-emerald-700 text-white h-7" onClick={() => { setFirmId(user.firm_id || ''); setOpen(true); }} data-testid="rehire-open-btn">
        <UserPlus className="h-3.5 w-3.5 mr-1" />Yeniden İşe Al
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="rehire-dialog">
          <DialogHeader>
            <DialogTitle>Yeniden İşe Al — {user.full_name}</DialogTitle>
            <DialogDescription>
              Önceki dönem ({user.employment_start_date ? new Date(user.employment_start_date).toLocaleDateString('tr-TR') : '?'} – {new Date(endDate).toLocaleDateString('tr-TR')}) Firma Geçmişi'nde saklanır. Kullanıcı pasifse aktif edilir.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1">
              <Label>Yeni işe başlama tarihi</Label>
              <Input type="date" min={endDate} value={startDate} onChange={(e) => setStartDate(e.target.value)} data-testid="rehire-start-date" />
            </div>
            <div className="space-y-1">
              <Label>Çalışacağı firma</Label>
              <Select value={firmId} onValueChange={setFirmId}>
                <SelectTrigger data-testid="rehire-firm-select"><SelectValue placeholder="Firma seçin" /></SelectTrigger>
                <SelectContent>
                  {firms.map((f) => <SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}
                </SelectContent>
              </Select>
              {firmId && firmId !== user.firm_id && (
                <p className="text-[11px] text-amber-600">Çalışan bu firmaya taşınacak; eski firmadaki kayıtlar orada kalır.</p>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>İptal</Button>
            <Button onClick={submit} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="rehire-submit">
              {saving && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Yeniden İşe Al
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
